import axios from '../config'
import { CLASS_MESSAGE_API } from '../baseURL'
import { LESSONPLAY_TOKEN } from '../../config/url';

export default {
    getMessage(type, param) {
        let token = window.localStorage.getItem(LESSONPLAY_TOKEN);
        return axios({
            url: CLASS_MESSAGE_API,
            method: "POST",
            data: {
                type,  						// 方法类型(必传)
                param, 					  	// 对应参数(必传)
                token						// 用户token(除两个登录方法外必传)
            }
        })
    },
    //获取学生信息
    getStudent(param) {
        let type = "getStudent";
        return this.getMessage(type, param)
    },
    //修改学生信息
    updateStudent(param) {
        let type = "updateStudent";
        return this.getMessage(type, param)
    },
    //获取学生所有班级
    getClassOfUser(params) {
        let type = "getClassOfUser";
        const param = {
            userGuid: params.userGuid,		// 用户guid(必传) 
            platformType: "laiye"        // 平台类型，不传则返回所有平台，传则返回特定类型平台
        };
        return this.getMessage(type, param)
    },
    //获取班级信息(包括单元及团队)
    getClassInfo(param) {
        let type = "classInfo";
        return this.getMessage(type, param)
    },
    //学生加入班级
    joinClass(param) {
        let type = "joinClass";
        return this.getMessage(type, param)
    },
    //搜索组织学校
    searchOrg(param) {
        let type = "searchOrg";
        return this.getMessage(type, param)
    },
    //获取班级成绩（完成度）
    getScoreList(param) {
        let type = "getScoreList";
        return this.getMessage(type, param)
    },
    //登录
    login(param) {
        let type = "login";
        return this.getMessage(type, param)
    },
    //根据邀请码进行查询班级
    classCode(param) {
        let type = "classCode";
        return this.getMessage(type, param)
    }
}



